/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  FormGroup,
  FormControl,
  InputGroup
} from "react-bootstrap";
import routes from "routes.js";


class HeaderLinks extends Component {
  constructor(){
    super();
    this.state = {
      username  : ''
    }
    this.logout = this.logout.bind(this);

  }
  logout()
  {
    
    localStorage.setItem('user', "");
    this.props.history.push('/auth/login-page');
    
  }
  componentDidMount(){
    var token = JSON.parse(localStorage.getItem('user'));  
    const  username = token.name
    this.setState({
      username : username
    })
  }
  render() {
    return (
      <div>
        <Navbar.Form pullLeft className="navbar-search-form">
          {/* <FormGroup>
            <InputGroup>
              <InputGroup.Addon>
                <i className="fa fa-search" />
              </InputGroup.Addon>
              <FormControl type="text" placeholder="Search..." />
            </InputGroup>
          </FormGroup> */}
        </Navbar.Form>
        <Nav pullRight>
          <NavItem eventKey={3} href="#">
              {/* {this.state.username} */}
          </NavItem>
           
          {/* <NavDropdown
            eventKey={4}
            title={
              <div>
                <i className="fa fa-user"  />
                <p className="hidden-md hidden-lg">
                  More
                  <b className="caret" />
                </p>
              </div>
            }
            noCaret
            id="basic-nav-dropdown-3"
            bsClass="dropdown-with-icons dropdown"
          > */}
            {/* <MenuItem eventKey={4.1}>
              <i className="pe-7s-mail" /> Messages
            </MenuItem>
            <MenuItem eventKey={4.2}>
              <i className="pe-7s-help1" /> Help Center
            </MenuItem>
            <MenuItem eventKey={4.3}>
              <i className="pe-7s-tools" /> Settings
            </MenuItem>
            <MenuItem divider />
            <MenuItem eventKey={4.4}>
              <i className="pe-7s-lock" /> Lock Screen
            </MenuItem> */}
              {/* <MenuItem eventKey={4.5}>
                <div className="text-danger">
                  <i className="pe-7s-close-circle" /> <a className="text-danger" > Log out</a>
                </div>
              </MenuItem> */}
          {/* </NavDropdown> */}
        </Nav>
      </div>
    );
  }
}
export default HeaderLinks;
